import { writable } from "svelte/store";

export const sshKeysOpen = writable(false);
